import { FC } from "react";


const Block: FC<{ height: string | number, backgroundColor?: string, style?: any }> = ({ height = 0, backgroundColor = "", style = {} }) => {
    return (
        <div style={{ height, marginRight: 0, marginLeft: 0, backgroundColor, ...style }} ></div>
    );
}

export default Block;